import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Subject } from 'rxjs';

import { HeaderHotlineDialogComponent } from './header-hotline-dialog/header-hotline-dialog.component';


@Component({
    selector: 'aa-header-hotline',
    standalone: false,
    templateUrl: './header-hotline.component.html',
    styleUrls: ['./header-hotline.component.scss']
})
export class HeaderHotlineComponent implements OnInit, OnDestroy {
    private destroyator = new Subject();
    notfCounter: number = 0;
    notfImportantCounter: number = 0;

    constructor(
        private dialog: MatDialog
    ) { }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    requestSupport() {
        this.dialog.open(HeaderHotlineDialogComponent, {
            width: '425px',
            maxWidth: '31vw',
            maxHeight: '99vh',
            panelClass: 'header-hotline-dialog-panel'
        });
    }
}
